import React, { useState } from 'react';
import type { SubscriptionFrequencyInfo } from 'autogen/swagger/all';
import AdvancedSelection from './AdvancedSelection';
import SimpleSelection from './SimpleSelection';

export default function FrequencySelection(subscriptionFrequencyInfo: SubscriptionFrequencyInfo): JSX.Element {
    const [showShortList, setShowShortList] = useState(true);

    function toggle() {
        setShowShortList(!showShortList);
    }

    return showShortList ? (
        <SimpleSelection subscriptionFrequencyInfo={subscriptionFrequencyInfo} toggleAdvanceCallback={toggle} />
    ) : (
        <AdvancedSelection subscriptionFrequencyInfo={subscriptionFrequencyInfo} toggleAdvanceCallback={toggle} />
    );
}
